/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Audit_High_Variance_ItemsInputs */

const en_audit_high_variance_items = /** @type {(inputs: Audit_High_Variance_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Items with >5% variance (${i?.count})`)
};

const es_audit_high_variance_items = /** @type {(inputs: Audit_High_Variance_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Articulos con >5% de variacion (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Items with >5% variance ({count})" |
*
* @param {Audit_High_Variance_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_high_variance_items = /** @type {((inputs: Audit_High_Variance_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_High_Variance_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_high_variance_items(inputs)
	return es_audit_high_variance_items(inputs)
});